module.exports = __webpack_public_path__ + "static/img/equ5.9a8c281a.png";